import { render, staticRenderFns } from "./OptionGroupMain.vue?vue&type=template&id=5e42d304&"
import script from "./OptionGroupMain.vue?vue&type=script&lang=js&"
export * from "./OptionGroupMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports